import React, { Component } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

class ShippingPolicy extends Component {
    render() {
        return (
            <div className="site-wrap">
                <Header page={'shipping'} />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><strong className="text-black">Shipping Policy</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className='textpara col-md-12'>
                                Thank you for shopping with Pelican Edu-Supply! We are committed to delivering your order promptly and in perfect condition. Please read our shipping policy to understand how we handle your orders.
                                <br /><br />
                                <strong>1. Shipping Locations</strong>
                                We currently ship to all locations within India. Unfortunately, we do not offer international shipping at this time.
                                <br /><br />
                                <strong>2. Shipping Methods & Delivery Times</strong>
                                <ul>
                                    <li><strong>Standard Shipping:</strong> Orders are processed and shipped within 1–3 business days from the date of purchase. Delivery time typically ranges from 5 to 7 business days, depending on the destination and geographical locations from our warehouses.</li>
                                    <li><strong>Express Shipping:</strong> For faster delivery, express shipping options may be available during checkout. Estimated delivery time for express shipping is 2–3 business days.</li>
                                    <li>Delivery times may vary depending on the location and availability of the products.</li>
                                </ul>
                                <strong>3. Shipping Charges</strong>
                                Shipping charges are calculated based on the weight, dimensions of the products, and the delivery location. The total shipping cost will be displayed during checkout before you complete your order.
                                <ul>
                                    <li><strong>Free Shipping:</strong> We offer free standard shipping on orders above ₹50000.</li>
                                    <li><strong>Shipping Charges:</strong> For orders below ₹500, a shipping fee will be applied, which will be displayed during the checkout process.</li>
                                </ul>
                                <strong>4. Order Processing & Dispatch</strong>
                                <ul>
                                    <li>Orders are typically processed within 1–2 business days, excluding weekends and public holidays.</li>
                                    <li>Once your order is dispatched, you will receive an email or SMS notification with tracking details to monitor your shipment.</li>
                                </ul>
                                <strong>5. Delivery Delays</strong>
                                While we strive to ensure timely delivery, there may be occasional delays due to factors beyond our control such as extreme weather conditions, national holidays, or logistical issues. In such cases, we will notify you as soon as possible.
                                <br /><br />
                                <strong>6. Missing or Damaged Items</strong>
                                If you receive an order with missing or damaged items, please contact us within 48 hours of receiving the package. We will investigate the issue and arrange for a replacement or refund if necessary.
                                <br /><br />
                                <strong>7. Address Issues</strong>
                                Please ensure that your shipping address is correct and complete. Pelican Edu-Supply is not responsible for delays or undelivered orders due to incorrect or incomplete addresses provided during checkout.
                                <br /><br />
                                <strong>8. Customs & Import Duties</strong>
                                As we currently only ship within India, customs and import duties are not applicable. If international shipping becomes available in the future, these charges will be the responsibility of the customer.
                                <br /><br />
                                <strong>9. Order Cancellation & Changes</strong>
                                Once an order has been processed and shipped, we are unable to cancel or make changes to it. Please make sure all details are correct before completing your order.
                                <br /><br />
                                <strong>10. Contact Us</strong>
                                If you have any questions about your order or shipping, feel free to contact us:
                                <ul>
                                    <li><strong>Email:</strong> pelicanpublishinghouse@gmail.com</li>
                                    <li><strong>Phone:</strong> 07207020941</li>
                                </ul>
                                We appreciate your understanding and thank you for choosing Pelican Edu-Supply!
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default ShippingPolicy;